var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"text":_vm.text,"notText":_vm.notText,"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }